import React from 'react'

const Blank = () => <div></div>

export default Blank;
